module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("To Catch a Thief")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("CHAPTER ONE")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Isle of Skye")])])])]), _c('p', {
    staticClass: "chapterDateline2"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Scotland")])])])]), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("S"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("HE WAS COLD")])])])]), _vm._v(" and tired and hungry. Her blistered feet ached and right now all Nell MacInnes wanted was a hot bath and a steaming cup of Earl Grey tea, followed by a warm bed to rest her weary body.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She closed her eyes, listening to the buzz of quiet pub conversation around her. The little inn nestled up against a pristine loch with towering mountains on three sides. The locals were far too polite to intrude on Nell’s reverie, and when she dumped her mountain gear and backpack on the floor, sinking into a worn wooden chair, no one raised an eyebrow.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It was heaven to be warm and dry after six days of climbing the nearby peaks, battling rain and wind on every ascent. If not for her climbing partner, Nell might have curtailed the trip three days sooner, but Eric’s enthusiasm was hard to resist. No doubt he would appear from his room upstairs within the hour, after taping his badly sprained ankle.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Warmth began to seep into her bones, as gentle as the low burr of the Scottish voices around her. Scotland was truly heaven, she thought.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And I’m telling you it was no such thing as my imagination, Angus McCrae. A grand fish it was—bigger than two arm spans, I’ll tell you this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Over the muted, good-natured argument about a lost fish, Nell heard the pub’s front door open. Cold wind snapped through the room as two men entered, scraping booted feet. “Where is the American man, Angus? We need the climber called MacInnes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell stiffened at the flawed description. Who wanted her now, when all she craved was one precious night’s rest? No one from San Francisco even knew she was in Scotland.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The man at the door wore a muddy parka and broken-in boots. A satphone was gripped at his chest. “We’ve bad weather up on the hill and I need the American—assuming the man’s as good as I’m told.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell took a short, wistful look at her half-eaten shepherd’s pie and the cup of tea, but a request for aid was never refused.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She gulped the rest of her tea and stood up. “I’m the American named MacInnes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You—a woman?” The man looked startled.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell nodded, used to the surprised glances after twelve years of climbing on four continents. “How can I help you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“A team of young climbers has gone missing on Blaven, and there’s bad weather already, with more due through the night.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Blaven")])]), _vm._v(".")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell recognized the name of the dark peaks that girded the valley on three sides. “They’re on the peak now?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Aye. They were expected down three hours ago and no sign of them yet. We have just now received word that they’re stranded.” He raised the satphone, his eyes grim. “A German climber saw them scattered out over the south slope like lost sheep. They did not answer his hails, and at least two had the look of being hurt.” His voice fell. “Badly hurt.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell thrust her arms into her waterproof jacket, already making mental notes. “How many are in the group and what level of climbing experience? I’ll need to know the exact coordinates where they were last seen, too.” Even in a blizzard, the GPS would help Nell track those missing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m assembling that information now.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell unzipped her pack, assessing her resources. “I’ll need drinking water and dried high-energy food, along with a more extensive first-aid kit.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I will have it prepared for you, Ms. MacInnes, and our thanks to you for your help. My SAR team is understaffed, all but myself sent over to assist in the recovery of plane crash victims on Uist. A terrible thing, that. I only wish I had two more people and I’d climb up myself.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, you’re right to stay here. Someone experienced needs to be available to coordinate resources and guide the authorities. Besides, I’m familiar with Blaven.” She smiled crookedly. “I worked SAR here myself nine years ago during my summer vacation.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The man looked pleasantly surprised—and a little relieved. “So you know the Cuillin, do you now? I’m glad to hear it. There are those who take our Cuillin lightly. Some of them do not live to learn their error, I’m afraid.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I won’t make that mistake, rest assured.” Nell’s voice was firm. She had seen enough dazed climbers and shattered bodies during her rescue summer to know just how fast conditions could change up on the nearby peaks. Within minutes an exhilarating climb could turn into a zero-visibility nightmare. “What’s the weather prediction up there?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Northerly gale force eight. Snow already falling on the summit. Temperatures dropping to minus nine Celsius.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell made the conversion to Fahrenheit quickly, taking the bottles of water and zippered food bags that the local SAR coordinator handed her. “One more thing.” Ruefully, she looked down at her feet. “I’m afraid I’ll need dry socks. These are fairly well soaked after walking down through the rain all day.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Without a word, every man in the now silent pub bent down and began to unlace shoes or unzip boots, hearing her quiet words.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In seconds hand-knit socks appeared on every table.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell smiled at this instant generosity.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She cleared her throat. “I appreciate your help. What I meant is, I have special climbing socks up in my room. I’ll do better with my own gear, you understand.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Of course.” The local SAR man said a few words of explanation in Gaelic. The men around Nell nodded. The socks vanished back on hidden feet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She started toward the stairs to her room, calculating exactly how much she could cram into her pack and what injuries the lost climbers might have incurred. There was only so much possibility for medical intervention on the top of a mountain with limited supplies.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“One word, miss. Your partner—he will be going with you, will he?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell shook her head. “Not with a sprained ankle, he won’t. But Eric will stay in contact. He can help you down here with backup arrangements. I’ll tell him the situation.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell knew her friend would insist on joining her, sprained ankle or not, but he’d be no help with an injury that had kept him limping for most of the day. She’d have to make the climb alone. She didn’t need any amateurs slowing her down.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll be down in two minutes. If someone can drive me up to the trailhead at the end of the loch, it will save twenty minutes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“A Land Rover is already waiting for you, miss.” The local rescue coordinator ran a hand through his hair. “I’d much prefer to go up the hill with you, truth be told. It’s a fair nasty stretch across the south slope in weather like this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll be fine.” Nell was calm, with years of climbing experience, focused on planning her route. She was used to facing the worst. Climbing a rugged peak in nasty weather wasn’t half as bad as the other shocks that life had thrown her.")])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('span')]), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("H"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("E WATCHED")])])])]), _vm._v(" her shoulder the heavy pack and then adjust both padded straps, working with the intense focus of someone used to carrying heavy weight well into the pain zone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The woman clearly knew what she was doing, Dakota thought, slouched out of sight inside a dusty delivery truck parked up the road from the inn. The bug in her backpack was working perfectly, allowing him clear access to every word she said. So far she’d made no slips. Her conversation with her climbing partner had been full of good-natured bantering and reminiscences of earlier climbs.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("No talk of art theft or organized terrorist activities, the Navy SEAL thought cynically.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His orders were absolutely clear. Close surveillance and assessment of all contacts made by Nell MacInnes. She’d done something to land on the government’s highest priority watch list.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Better than anyone, Dakota Smith knew that SEALs didn’t get called up for aimless threats. Nell MacInnes was up to her slender neck in trouble.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With or without her father’s help, she was suspected of participating in the theft of one of the most valuable pieces of art ever to enter the National Gallery. Dakota’s job was to find out who she was working with and locate the stolen Renaissance masterpiece before it vanished forever, traded through a shadow network of international criminals, sold to finance the activities of an elusive terrorist group active on American soil.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The SEAL’s eyes narrowed on the woman’s back as she climbed into a battered Land Rover, accompanied by the head of the local search-and-rescue volunteer team. Dakota wondered what made her tick, what drove her back out into a pounding storm after six days of strenuous climbing. He doubted it was simple selflessness. No, he figured that Nell MacInnes enjoyed walking on the edge, tasting danger. She looked like a classic thrill seeker, which would also explain her involvement in a complicated, high-stakes robbery.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Not greed. She didn’t drive a late-model Maserati or own a string of houses. Her apartment back in San Francisco was neat but small, and her only hobby appeared to be climbing. Yet appearances could be the most unreliable thing in the world, Dakota knew.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Still, he wondered about that brief note of resignation he’d heard in Nell’s voice back at the pub. The confidence had faded, along with the high energy, and she had sounded tired and worried, as if she genuinely cared about the missing climbers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Forget about the target’s emotions,")])]), _vm._v(" a voice warned flatly as Dakota pulled onto the road, following the Land Rover at a careful distance. He’d track her up the brooding slopes of Blaven and make certain she came down in one piece. But he’d break his cover to save the other climbers only if it was absolutely necessary, mindful of his orders to stay well under the radar until all Nell MacInnes’s shadowy contacts were bagged and tagged. The mission came first.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Always.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("After parking down the slope from the small trailhead, Dakota pulled on an all-weather parka and a fully stocked backpack, then fingered his shortwave radio. His contact would be waiting for an update. “Teague, are you there?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yo.” Izzy Teague’s voice was clear, despite an edge of static. “I’ve got the topo map on the screen in front of me. I checked with SAR and got the coordinates. You’ll have a straight ascent for an hour, followed by a fairly strenuous climb through shifting rock when you near the south face. A chopper is on its way over from the mainland, but the weather may prevent a landing until tomorrow.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So I’m on my own,” Dakota said calmly. “Fine with me. I don’t need anyone slowing me down or asking questions.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Watch out for yetis up there,” Izzy said wryly. “I’ll keep a bottle of Glenlivet on ice for you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You do that. Alpha out.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The dark face of Blaven was veiled in clouds as Nell set off up the rocky trail. The Land Rover headed down to the inn. The first wet flakes of gale-driven snow lashed at Dakota’s face as he started up toward Blaven’s brooding darkness, Nell already out of sight before him.")])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('span')]), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("OR SOME REASON")])])])]), _vm._v(" she couldn’t shake the sense that she was being followed. For the third time Nell stopped, peering through fingers of clouds, looking for other climbers behind her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Only rocky slopes met her sharp scrutiny.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Of course you’re alone, idiot. Any climbers with good sense are inside huddled before a roaring fire right now.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But a climber didn’t turn away in an emergency. Rules of the road.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rules of life, too.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Turning back into the cutting wind, Nell nursed her aching right knee and chose each step, careful not to trigger a slide in the loose rock. Her face was cold, wet from the wind driving up from the sea. She estimated she’d reach the missing climbers’ last coordinates in another twenty minutes. If the weather didn’t shift, she could begin guiding them down off the peak immediately.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But Nell was prepared for a dozen unknown variables from shattered morale to shattered ankles. Any one of them could hamper a fast descent.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("No point tilting at windmills, MacInnes.")])]), _vm._v(" Every rescue was different, so she’d tackle each obstacle as it appeared. She eased her pack lower on her shoulders, trying to stay loose.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Once again she was struck by the twitchy feeling that someone was down the slope in shadow.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Watching her.")])]), _c('p', {
    staticClass: "chapterDateline1"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Blaven face.")])])])]), _c('p', {
    staticClass: "chapterDateline2"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("One hour before sunset.")])])])]), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("W"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("IND RAKED")])])])]), _vm._v(" Dakota’s neck.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Icy rain howled over the cliff overlooking the restless Sea of Hebrides.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Visibility was down to zero and already the storm was driving intermittent gusts of nearly sixty miles per hour.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Over the slope Nell MacInnes had made contact with the frightened climbers. Thanks to the howl of the wind, Dakota could only pick up one word in three, but from what he heard, Nell was dealing with the rescue quickly and by the book.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She assessed injuries, boosted morale and passed out dry trail rations and chocolate, then radioed down to the SAR leader to have transport with a medical team waiting at the foot of the mountain. The climbers were teenagers from an international school in London, and their leader, a burly ex-naval officer from Brighton, was clearly out of his element. Why he had tried the ascent was still unclear, but Dakota knew the speed of weather changes on Skye could take anyone by surprise.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He fingered his transmitter. “Alpha to Teague.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Instantly static crackled. “Pizza to go. What can I get you, Alpha?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I figure a large cheese with double pepperoni is out,” Dakota said dryly. “So I’ll settle for backup medical response at the lower trailhead. One girl up here has full-blown asthma with signs of respiratory distress.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Roger that. I’ll wander on by to help and make sure it looks like a coincidence. What about the other climbers?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“There are seven in all, plus their leader, Ian Westlake. He might have had a heart attack. He’s holding on, but he’s no help to anyone. Nell’s about to try guiding the able ones down and I’m going to meet her on the slope to help out.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Copy that. Better get the lead out, Alpha. That storm is picking up speed.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Bad news, Dakota thought. “Roger. I’ll check back in ten. Alpha out.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The SEAL stared across the slope. To his right a steep cliff fell away in a vertical drop straight down to the loch. To his left a lower ridge vanished into the notched teeth of the Cuillin range.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("There would be no climbing down tonight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They were on their own. No rescue chopper could land in this wind, even if any were available in this remote corner of Skye. Dakota had to help Nell hold the kids together, dig in on the ledge for the night and wait out the storm.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In exactly eight minutes he rounded a turn and saw the little group, huddled beneath a ledge. Nell was snapping out crisp orders to a gangly teenager in a brand new parka.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hamilton, get your pack lashed over that boulder. Then I want you and Meyerson inside your tent in sixty seconds.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, sir. I mean ma’am.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Once the boy’s pack was secure, he joined his terrified partner in the tent that had been pitched and tethered around stones in the lee of the wind.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("What lee there was.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Another icy gust pounded over the ridge.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Wu, secure your tent. Hernandez, get that lantern ready to help him.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dakota watched Nell work beside the kids, making temporary shelter. She was using their last names, which created distance and the comfort of hierarchy, making orders easier to give and follow.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He noted that two other boys were working to secure another tent to nearby boulders, with packs tied down near the tent entrance.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Good job,” Nell called. “Now all of you get inside.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("So where were the wounded ones? Dakota wondered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A tent flap opened. A slim girl crawled out, looking for Nell. “I found that radio you asked about, ma’am. “It’s—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Wilson, go back inside and take cover. This wind is—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The rest of Nell’s order was swept away in an icy gust that screamed over the ridge, caught two unsecured backpacks and threw them into the teenage girl, knocking her into a spine of sharp granite. As her scream was swallowed by the wind, Dakota dove forward and caught her waist, pulling her away from the cliff edge. She moaned brokenly as he lifted her into his arms. Blood streamed over his fingers from a gash down the side of her forehead. Dakota noted her erratic pulse and diminished pupil response.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Neck wound and probable concussion. Internal injuries were also possible.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Who the heck are you?” Nell blocked his way, looking angry and wary and relieved, all at the same time.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I was climbing over on the far side of Blaven when I picked up a distress alert from the local SAR. I changed route, circled the corrie and came up to see if you needed help.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell bit her lip, studying him intently. “You’re American.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Navy.” Dakota gave a wry smile. “This was supposed to be a little holiday until I’m redeployed out of Coronado. I wasn’t counting on the weather going all to hell.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell seemed to relax slightly. “It does that a lot here. So you’re a good climber? Can you help me get these kids down?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll do whatever I can. Say the word.” Dakota frowned. “You’re up here alone?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yeah, I am. Look—it’s a long story and I don’t have time to fill in the gaps. I’m Nell MacInnes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Lieutenant Dakota Smith.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well, Lieutenant Smith, you can put Amanda Wilson inside this tent.” As she pointed to her right, wet sheeting snow cut off every sign of the terrain. “All of you stay in your tents and keep your backs to the rock. No one moves. Hammond, get that flap closed.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dakota checked his watch as the teens obeyed Nell’s terse commands. She had chosen the camp site well, bunkered down under a ledge in the narrow rift between two cliff faces.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The teenagers looked cold and confused as Nell went from tent to tent, giving calm orders. “Remember, you are fit and you are smart. We "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("will")])]), _vm._v(" survive this. Lieutenant Smith out there is going to help us.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But what about Amanda?” A younger boy cut in, his voice shrill with panic. “She hit her head. Is she going to be okay?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She’ll pull through.” Dakota’s voice was firm as he set the wounded girl carefully in the tent Nell had pointed out. Despite his assurances, he knew the girl was far from safe. If she had internal injuries, she might not last the night without medical intervention.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Briefly, he considered packing the wounded girl into an improvised travois and pulling her down as soon as visibility returned. But that would leave Nell alone in deteriorating conditions—and protecting Nell was his mission priority.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("FUBAR.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As he rose from the tent, the wind howled over the ridge. Nell staggered, tossed sideways, and Dakota caught her quickly, his arms locked around her waist.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He felt the strength of her slim body as she fought the wind, trying to stand. “Thanks,” she rasped. “We’d better get inside.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Beneath her safety helmet her eyes were calm and dark, the color of racing gray water through the mountains near his home in northern California. As the two squeezed inside the tent next to the girl named Amanda, Dakota pulled a silver thermal blanket out of his backpack. “Looks like you could use this. The girl’s shivering. She doesn’t seem to be breathing very well either.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Asthma.” Nell spread the blanket over the girl’s body and tucked it in. “Thanks again, Lieutenant—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Dakota will do fine.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t suppose you’ve got a few other seasoned climbers with you who could help guide these kids down?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Afraid not. I’m traveling alone.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell glanced at him intently. “Not many people I know climb alone.” She raised an eyebrow, waiting for his answer.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If I wanted noise and crowds, I would have stayed in London,” he said easily. “I prefer climbing alone.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She nodded. “I can understand that.” She unclipped a rope from her belt and wrapped it in neat coils, every movement smooth and precise.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She was definitely a professional, Dakota thought. He gave a small nod toward the motionless girl and the boy at the other side of the tent. “She needs care. The sooner the better.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Tell me something I don’t know,” Nell muttered. She turned to the other frightened teen, made a little light banter, then leaned back toward Dakota. She studied his shoulders, his high-tech boots and climbing gear. “How good are you, Lieutenant?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Good enough.” There was no empty boasting, just cool truth in the words.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then you can help me rope a safety line?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dakota shook his head. “Maybe you haven’t looked outside. This storm is gaining steam. I heard that sixty-mile-an-hour gusts were clocked near Portee. With windchill factored in, we—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We’re screwed,” Nell said quietly. “I got that much already. Right now as I see it, our only choice is to get these kids down as soon as possible. They’re not dressed for a night of wet, freezing conditions.” Short copper hair tumbled around her flushed cheeks as she leaned down to check Amanda Wilson’s pulse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dakota had seen that hair before. He’d seen her excited and tired. But he’d never seen her so focused or so worried, as if these kids really mattered to her. Somehow it didn’t fit with the thrill-seeker image captured in her file.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But what she was suggesting was one step short of crazy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You can’t get them down in a whiteout. One wrong step and they plunge into freefall, and you’ll go over with them.” Dakota kept his voice low so the others wouldn’t hear. “We’ll have to stay put.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nell looked down at the girl named Amanda, whose breathing was growing more labored. “I know a way. This ridge leads down to a back trail. If you help me, I can set a safety line in fifteen minutes. I can get them down one at a time after that.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll clip each one into a harness, secure them to the safety line and work back down to the mid-peak.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’ve got only an hour of light left, and that will be pushing it.” Dakota stared out the tent flap at the gray slope. He didn’t like the risks—not for Nell or the stranded kids. “Have you ever handled a rescue like this?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“At least a dozen times. A lot of climbers get cocky and forget that the weather up here can change on a dime. But I can get these kids down to the SAR meeting point. Trust me, I know this area pretty well.” Her mouth curved in a sudden smile, and Dakota blinked at the force of the determination. Did "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("anyone")])]), _vm._v(" say no to Nell MacInnes?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The danger didn’t seem to bother her, and her choices seemed logical. A good leader took controlled risks as necessary.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dakota couldn’t help but admire her courage and her skill.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ve got a radio for contact. I’ve also got this.” Nell pulled a silver whistle from inside her parka. “The SAR people will be expecting an alert once I’m close to the bottom of the safety line. I’ll hand off each teenager and then head back up.” She smiled gamely and gave an experimental whistle. “But if we’re going to do this, it has to be now.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dakota had to admit that her plan made sense, especially since staying put offered a risk of exposure and hypothermia.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But habit was habit. A SEAL never trusted any plan he hadn’t tested himself. Watching on the sidelines wasn’t in a SEAL’s job description.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He had to keep Nell safe.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But he couldn’t let any of these kids die in the process.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He watched Nell slide her climbing rope through her fingers, testing each coil. The fibers were smooth with no frays, clearly well tended.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She tugged on fingerless climbing gloves, frowning. “Look, Lieutenant—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Dakota.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We have to move, Dakota. In twenty minutes we really will be boxed in here. Do you want to save these kids or not?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I want to see "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("all")])]), _vm._v(" of you get down safely.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t worry about me. Last year I took third at Chamonix. That’s an open climb with professionals—both men and women.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But you were probably climbing in good weather, fully roped and hydrated.” He glanced back and lowered his voice. “These kids are frightened and near the end of their endurance.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll get them down the ridge. My safety line will hold, trust me.” Nell leaned closer, her voice falling. “Otherwise we could lose them up here in the cold.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dakota listened to the howl of the wind beyond their narrow, protected ridge. It was a perilous point of safety, one that would vanish as the temperature fell and the poorly dressed group of kids faced hypothermia. With gale-force winds in a whiteout, the disoriented teens could crack at any minute, driven by panic to do something stupid.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was trained to be flexible, and he did that now, assessing the choices and the risks. As wind roared over the ridge, Dakota made his decision.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He zipped up his parka. “Show me where you want to set this safety line.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d90af9f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tocatchathief_ch01.vue
// module id = 81
// module chunks = 0